import styled from 'styled-components';

interface ContainerProps {
  width?: string;
  height?: string;
  margin?: string;
  padding?: string;
  alignItems?: string;
  bgColor?: string;
  border?: string;
  borderRadius?: string;
  marginLeft?: string;
  position?: string;
  top?: string;
  marginTop?: string;
  left?: string;
  opacity?: string;
  overflow?: string;
  overflowY?: string;
  boxShadow?: string;
  display?: string;
  zIndex?: string;
  justifyContent?: string;
  transform?: string;
  cursor?: string;
}

// List of custom props that should NOT be forwarded to the DOM element
const CUSTOM_PROPS = new Set([
  'width', 'height', 'margin', 'padding', 'alignItems', 'bgColor', 'border',
  'borderRadius', 'marginLeft', 'position', 'top', 'marginTop', 'left',
  'opacity', 'overflow', 'overflowY', 'boxShadow', 'display', 'zIndex',
  'justifyContent', 'transform', 'cursor',
]);

const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !CUSTOM_PROPS.has(prop),
})<ContainerProps>`
  width: ${(props) => props.width ?? ""};
  height: ${(props) => props.height ?? ""};
  margin: ${(props) => props.margin ?? ""};
  padding: ${(props) => props.padding ?? ""};
  align-items: ${(props) => props.alignItems ?? ""};
  background-color: ${(props) => props.bgColor ?? ""};
  border-radius: ${(props) => props.borderRadius ?? ""};
  margin-left: ${(props) => props.marginLeft ?? ""};
  position: ${(props) => props.position ?? ""};
  border: ${(props) => props.border ?? ""};
  top: ${(props) => props.top ?? ""};
  margin-top: ${(props) => props.marginTop ?? ""};
  left: ${(props) => props.left ?? ""};
  opacity: ${(props) => props.opacity ?? ""};
  overflow: ${(props) => props.overflow ?? ""};
  overflow-y: ${(props) => props.overflowY ?? ""};
  box-shadow: ${(props) => props.boxShadow ?? ""};
  display: ${(props) => props.display ?? ""};
  z-index: ${(props) => props.zIndex ?? ""};
  justify-content: ${(props) => props.justifyContent ?? ""};
  transform: ${(props) => props.transform ?? ""};
  cursor: ${(props) => props.cursor ?? ""};
`;

export default Container;
